import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_284: DocMigration = {
  maxSchemaVersion: "0.0.284",
  description: "Rename doc.posts to doc.railingPosts",
  apply(json: any): any {
    json.railingPosts = { ...json.posts };
    delete json.posts;
    return json;
  },
};

export default migration_0_0_284;
